var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0830078 3.81395C0.0830078 1.98371 1.56672 0.5 3.39696 0.5H11.7691C13.5993 0.5 15.083 1.98371 15.083 3.81395V12.186C15.083 14.0163 13.5993 15.5 11.7691 15.5H3.39696C1.56672 15.5 0.0830078 14.0163 0.0830078 12.186V3.81395ZM3.39696 1.54651C2.14469 1.54651 1.12952 2.56168 1.12952 3.81395V12.186C1.12952 13.4383 2.14469 14.4535 3.39696 14.4535H11.7691C13.0213 14.4535 14.0365 13.4383 14.0365 12.186V3.81395C14.0365 2.56168 13.0213 1.54651 11.7691 1.54651H3.39696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnCheckBox);
export default __webpack_public_path__ + "static/media/IconUnCheckBox.16475a4fc84af59973edf9ba634aae17.svg";
export { ForwardRef as ReactComponent };